// import React, { useState, useCallback } from "react";
// import DataTable from "react-data-table-component";
// import { 
//     Tag, 
//     Button, 
//     Card, 
//     Row, 
//     Col, 
//     Input, 
//     Space, 
//     Typography, 
//     Alert, 
//     Spin, 
//     Statistic, 
//     Divider, 
//     Empty,
//     Progress,
//     Tooltip,
//     Badge
// } from "antd";
// import { toast } from "react-toastify";
// import { postRequest } from "./../../../Utils/AppApi";
// import { LEDGER_CORRECT_API } from "./../../../Utils/appConstants";
// import { 
//     ReloadOutlined, 
//     ClearOutlined, 
//     PlusOutlined, 
//     CheckCircleOutlined, 
//     ClockCircleOutlined, 
//     CloseCircleOutlined, 
//     ExclamationCircleOutlined,
//     UserOutlined,
//     DatabaseOutlined,
//     SafetyCertificateOutlined,
//     LoadingOutlined,
//     RocketOutlined,
//     FilterOutlined
// } from "@ant-design/icons";

// const { TextArea } = Input;
// const { Title, Paragraph, Text } = Typography;

// const WalletCorrectionPage = ({ history }) => {
//     const [inputValue, setInputValue] = useState("");
//     const [users, setUsers] = useState([]);
//     const [processingUser, setProcessingUser] = useState(null);
//     const [isProcessingBatch, setIsProcessingBatch] = useState(false);

//     const handleInputChange = useCallback((e) => {
//         setInputValue(e.target.value.replace(/\s/g, "").toUpperCase());
//     }, []);

//     const generateList = useCallback(() => {
//         if (!inputValue.trim()) {
//             return toast.error("Please enter at least one username");
//         }

//         const rawUsers = inputValue
//             .split(/,|\n/)
//             .map(u => u.trim())
//             .filter(Boolean);

//         const uniqueUsers = [...new Set(rawUsers)].filter(u => u.length > 0 && /^[A-Z0-9]+$/.test(u));

//         if (uniqueUsers.length === 0) {
//             return toast.error("No valid usernames found. Use uppercase alphanumeric characters only.");
//         }

//         if (uniqueUsers.length !== rawUsers.length) {
//             toast.warning(`Removed ${rawUsers.length - uniqueUsers.length} invalid or duplicate entries.`);
//         }

//         const list = uniqueUsers.map(u => ({
//             key: u,
//             username: u,
//             status: "PENDING",
//             timestamp: new Date().toISOString()
//         }));

//         setUsers(list);
//         toast.success(`Queue generated with ${list.length} unique users.`);
//     }, [inputValue]);

//     const updateStatus = useCallback((username, status) => {
//         setUsers(prev =>
//             prev.map(u =>
//                 u.username === username ? { 
//                     ...u, 
//                     status,
//                     updatedAt: new Date().toISOString()
//                 } : u
//             )
//         );
//     }, []);

//     const handleCorrectWallet = useCallback((row) => {
//         if (row.status !== "PENDING") return;

//         setProcessingUser(row.username);
//         updateStatus(row.username, "PROCESSING");

//         const payload = { username: row.username.toUpperCase() };

//         postRequest(LEDGER_CORRECT_API, payload, history)
//             .then(res => {
//                 if (res?.success) {
//                     toast.success(`✓ Wallet corrected successfully for ${row.username}`);
//                     updateStatus(row.username, "DONE");
//                 } else {
//                     toast.error(res?.message || "Correction failed");
//                     updateStatus(row.username, "FAILED");
//                 }
//             })
//             .catch(() => {
//                 toast.error("API request failed");
//                 updateStatus(row.username, "FAILED");
//             })
//             .finally(() => setProcessingUser(null));
//     }, [history, updateStatus]);

//     const handleBatchCorrect = useCallback(async () => {
//         const pendingUsers = users.filter(u => u.status === "PENDING");
//         if (pendingUsers.length === 0) {
//             toast.info("No pending users to process");
//             return;
//         }

//         setIsProcessingBatch(true);
        
//         for (const user of pendingUsers) {
//             try {
//                 setProcessingUser(user.username);
//                 updateStatus(user.username, "PROCESSING");
                
//                 const payload = { username: user.username.toUpperCase() };
//                 const res = await postRequest(LEDGER_CORRECT_API, payload, history);
                
//                 if (res?.success) {
//                     updateStatus(user.username, "DONE");
//                 } else {
//                     updateStatus(user.username, "FAILED");
//                 }
                
//                 // Small delay between requests to prevent overwhelming the API
//                 await new Promise(resolve => setTimeout(resolve, 300));
//             } catch (error) {
//                 updateStatus(user.username, "FAILED");
//             } finally {
//                 setProcessingUser(null);
//             }
//         }
        
//         setIsProcessingBatch(false);
//         toast.success(`Batch processing completed`);
//     }, [users, history, updateStatus]);

//     const clearQueue = useCallback(() => {
//         setUsers([]);
//         setInputValue("");
//         toast.info("Queue cleared.");
//     }, []);

//     const statusTag = useCallback((status) => {
//         const statusConfig = {
//             DONE: { 
//                 color: "success", 
//                 text: "Completed", 
//                 icon: <CheckCircleOutlined />,
//                 variant: "filled"
//             },
//             FAILED: { 
//                 color: "error", 
//                 text: "Failed", 
//                 icon: <CloseCircleOutlined />,
//                 variant: "outlined"
//             },
//             PROCESSING: { 
//                 color: "processing", 
//                 text: "Processing", 
//                 icon: <LoadingOutlined spin />,
//                 variant: "filled"
//             },
//             PENDING: { 
//                 color: "default", 
//                 text: "Pending", 
//                 icon: <ClockCircleOutlined />,
//                 variant: "outlined"
//             }
//         };

//         const config = statusConfig[status] || statusConfig.PENDING;
//         return (
//             <Tag 
//                 color={config.color} 
//                 icon={config.icon} 
//                 style={{ 
//                     fontWeight: 500,
//                     borderRadius: "12px",
//                     padding: "2px 10px",
//                     border: config.variant === "outlined" ? "1px solid #d9d9d9" : "none"
//                 }}
//             >
//                 {config.text}
//             </Tag>
//         );
//     }, []);

//     const getStatusCounts = useCallback(() => {
//         return users.reduce((acc, user) => {
//             acc[user.status] = (acc[user.status] || 0) + 1;
//             return acc;
//         }, {});
//     }, [users]);

//     const getCompletionPercentage = useCallback(() => {
//         if (users.length === 0) return 0;
//         const completed = users.filter(u => u.status === "DONE").length;
//         return Math.round((completed / users.length) * 100);
//     }, [users]);

//     const columns = [
//         {
//             name: <Space><UserOutlined />Username</Space>,
//             selector: row => row.username,
//             sortable: true,
//             width: "250px",
//             cell: row => (
//                 <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                     <div style={{
//                         width: "32px",
//                         height: "32px",
//                         borderRadius: "50%",
//                         background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                         display: "flex",
//                         alignItems: "center",
//                         justifyContent: "center",
//                         color: "white",
//                         fontWeight: "bold"
//                     }}>
//                         {row.username.charAt(0)}
//                     </div>
//                     <Text strong style={{ fontFamily: "'JetBrains Mono', monospace" }}>
//                         {row.username}
//                     </Text>
//                 </div>
//             )
//         },
//         {
//             name: <Space><ClockCircleOutlined />Status</Space>,
//             selector: row => row.status,
//             sortable: true,
//             width: "150px",
//             center: true,
//             cell: row => statusTag(row.status)
//         },
//         {
//             name: "Actions",
//             width: "140px",
//             right: true,
//             cell: row => (
//                 <div style={{ display: "flex", justifyContent: "flex-end" }}>
//                     {row.status === "DONE" ? (
//                         <Button 
//                             size="small" 
//                             type="text" 
//                             icon={<CheckCircleOutlined style={{ color: "#52c41a" }} />} 
//                             disabled
//                             style={{ color: "#52c41a" }}
//                         >
//                             Done
//                         </Button>
//                     ) : row.status === "PROCESSING" ? (
//                         <Spin size="small" indicator={<LoadingOutlined spin />}>
//                             <Button size="small" type="default" disabled>
//                                 Processing
//                             </Button>
//                         </Spin>
//                     ) : (
//                         <Tooltip title="Correct wallet ledger">
//                             <Button
//                                 type="primary"
//                                 size="small"
//                                 icon={<ReloadOutlined />}
//                                 onClick={() => handleCorrectWallet(row)}
//                                 loading={processingUser === row.username}
//                                 style={{ 
//                                     borderRadius: "6px",
//                                     background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                                     border: "none"
//                                 }}
//                             >
//                                 Correct
//                             </Button>
//                         </Tooltip>
//                     )}
//                 </div>
//             )
//         }
//     ];

//     const statusCounts = getStatusCounts();
//     const totalCount = users.length;
//     const pendingCount = statusCounts.PENDING || 0;
//     const completedCount = statusCounts.DONE || 0;
//     const failedCount = statusCounts.FAILED || 0;
//     const completionPercentage = getCompletionPercentage();

//     return (
//         <div style={{ 
//             backgroundColor: "#f8fafc", 
//             minHeight: "100vh", 
//             padding: "24px 0",
//             fontFamily: "'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif"
//         }}>
//             <div className="container-fluid" style={{ maxWidth: "1400px", margin: "0 auto" }}>
//                 {/* Header Section */}
//                 {/* <Row style={{ marginBottom: "32px" }}>
//                     <Col span={24}>
//                         <div style={{ 
//                             padding: "24px 32px",
//                             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                             borderRadius: "16px",
//                             color: "white",
//                             boxShadow: "0 8px 32px rgba(102, 126, 234, 0.2)"
//                         }}>
//                             <Space direction="vertical" size="small" style={{ width: "100%" }}>
//                                 <Space align="center" size="middle">
//                                     <SafetyCertificateOutlined style={{ fontSize: "32px" }} />
//                                     <Title level={2} style={{ margin: 0, color: "white" }}>
//                                         Wallet Ledger Correction
//                                     </Title>
//                                 </Space>
//                                 <Paragraph style={{ color: "rgba(255,255,255,0.9)", margin: 0 }}>
//                                     Enterprise-grade wallet ledger correction system. Process multiple users with precision and reliability.
//                                 </Paragraph>
//                             </Space>
//                         </div>
//                     </Col>
//                 </Row> */}

//                 <Row gutter={[32, 32]}>
//                     {/* Left Column - Input Section */}
//                     <Col xs={24} lg={8}>
//                         <Card
//                             title={
//                                 <Space>
//                                     <DatabaseOutlined />
//                                     <Text strong>Input Configuration</Text>
//                                 </Space>
//                             }
//                             bordered={false}
//                             style={{ 
//                                 borderRadius: "16px",
//                                 boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
//                                 height: "100%"
//                             }}
//                         >
//                             <Space direction="vertical" size="large" style={{ width: "100%" }}>
//                                 <div>
//                                     <Text strong style={{ display: "block", marginBottom: "8px", color: "#334155" }}>
//                                         Enter Usernames
//                                     </Text>
//                                     <Text type="secondary" style={{ fontSize: "12px", display: "block", marginBottom: "12px" }}>
//                                         Separate by commas or new lines. Uppercase alphanumeric only.
//                                     </Text>
//                                     <TextArea
//                                         rows={6}
//                                         placeholder="SRPAY1011, SRPAY1012&#10;SRPAY1013, SRPAY1014"
//                                         value={inputValue}
//                                         onChange={handleInputChange}
//                                         style={{ 
//                                             fontFamily: "'JetBrains Mono', monospace",
//                                             fontSize: "14px",
//                                             borderRadius: "12px",
//                                             border: "1px solid #e2e8f0",
//                                             resize: "none"
//                                         }}
//                                     />
//                                 </div>
                                
//                                 <div>
//                                     <Text strong style={{ display: "block", marginBottom: "12px", color: "#334155" }}>
//                                         Quick Actions
//                                     </Text>
//                                     <Space direction="vertical" style={{ width: "100%" }}>
//                                         <Button
//                                             type="primary"
//                                             icon={<PlusOutlined />}
//                                             size="large"
//                                             onClick={generateList}
//                                             block
//                                             style={{ 
//                                                 height: "48px",
//                                                 borderRadius: "12px",
//                                                 fontWeight: 500,
//                                                 background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                                                 border: "none"
//                                             }}
//                                         >
//                                             Generate Queue
//                                         </Button>
                                        
//                                         {users.length > 0 && (
//                                             <>
                                              
                                                
//                                                 <Button
//                                                     danger
//                                                     icon={<ClearOutlined />}
//                                                     size="large"
//                                                     onClick={clearQueue}
//                                                     block
//                                                     style={{ 
//                                                         height: "48px",
//                                                         borderRadius: "12px",
//                                                         fontWeight: 500
//                                                     }}
//                                                 >
//                                                     Clear Queue
//                                                 </Button>
//                                             </>
//                                         )}
//                                     </Space>
//                                 </div>
//                             </Space>
//                         </Card>
//                     </Col>

//                     {/* Right Column - Queue Section */}
//                     <Col xs={24} lg={16}>
//                         <Card
//                             bordered={false}
//                             style={{ 
//                                 borderRadius: "16px",
//                                 boxShadow: "0 4px 24px rgba(0,0,0,0.06)",
//                                 height: "100%"
//                             }}
//                             bodyStyle={{ padding: "24px" }}
//                         >
//                             {/* Stats Overview */}
//                             {users.length > 0 ? (
//                                 <>
//                                     <div style={{ marginBottom: "32px" }}>
//                                         <Space direction="vertical" size="middle" style={{ width: "100%" }}>
//                                             <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
//                                                 <Space>
//                                                     <Title level={4} style={{ margin: 0 }}>Correction Progress</Title>
//                                                     <Badge count={totalCount} style={{ backgroundColor: "#667eea" }} />
//                                                 </Space>
//                                                 <Text strong style={{ color: "#667eea", fontSize: "24px" }}>
//                                                     {completionPercentage}%
//                                                 </Text>
//                                             </div>
                                            
//                                             <Progress 
//                                                 percent={completionPercentage} 
//                                                 strokeColor={{
//                                                     '0%': '#667eea',
//                                                     '100%': '#764ba2',
//                                                 }}
//                                                 strokeWidth={8}
//                                                 showInfo={false}
//                                                 style={{ marginBottom: "16px" }}
//                                             />
                                            
//                                             <Row gutter={[16, 16]}>
//                                                 <Col xs={6}>
//                                                     <Statistic 
//                                                         title="Total" 
//                                                         value={totalCount}
//                                                         prefix={<DatabaseOutlined />}
//                                                         valueStyle={{ color: "#334155" }}
//                                                     />
//                                                 </Col>
//                                                 <Col xs={6}>
//                                                     <Statistic 
//                                                         title="Pending" 
//                                                         value={pendingCount}
//                                                         valueStyle={{ color: "#f59e0b" }}
//                                                     />
//                                                 </Col>
//                                                 <Col xs={6}>
//                                                     <Statistic 
//                                                         title="Completed" 
//                                                         value={completedCount}
//                                                         valueStyle={{ color: "#10b981" }}
//                                                     />
//                                                 </Col>
//                                                 <Col xs={6}>
//                                                     <Statistic 
//                                                         title="Failed" 
//                                                         value={failedCount}
//                                                         valueStyle={{ color: "#ef4444" }}
//                                                     />
//                                                 </Col>
//                                             </Row>
//                                         </Space>
//                                     </div>

//                                     {/* Data Table */}
//                                     <DataTable
//                                         columns={columns}
//                                         data={users}
//                                         highlightOnHover
//                                         pagination
//                                         paginationPerPage={10}
//                                         paginationRowsPerPageOptions={[5, 10, 25, 50]}
//                                         noDataComponent={
//                                             <Empty
//                                                 description="No users in queue"
//                                                 image={Empty.PRESENTED_IMAGE_SIMPLE}
//                                             />
//                                         }
//                                         customStyles={{
//                                             table: {
//                                                 style: {
//                                                     borderRadius: "12px",
//                                                     overflow: "hidden",
//                                                     border: "1px solid #f1f5f9"
//                                                 }
//                                             },
//                                             headRow: {
//                                                 style: {
//                                                     backgroundColor: "#f8fafc",
//                                                     borderBottom: "2px solid #e2e8f0",
//                                                     fontWeight: 600,
//                                                     fontSize: "14px"
//                                                 }
//                                             },
//                                             headCells: {
//                                                 style: {
//                                                     fontWeight: 600,
//                                                     color: "#334155",
//                                                     fontSize: "13px",
//                                                     textTransform: "uppercase",
//                                                     letterSpacing: "0.5px"
//                                                 }
//                                             },
//                                             rows: {
//                                                 style: {
//                                                     borderBottom: "1px solid #f1f5f9",
//                                                     "&:hover": { 
//                                                         backgroundColor: "#f8fafc",
//                                                         transform: "translateY(-1px)",
//                                                         transition: "all 0.2s ease"
//                                                     }
//                                                 }
//                                             },
//                                             pagination: {
//                                                 style: {
//                                                     borderTop: "1px solid #f1f5f9",
//                                                     padding: "16px 0"
//                                                 }
//                                             }
//                                         }}
//                                     />
//                                 </>
//                             ) : (
//                                 <Empty
//                                     description={
//                                         <Space direction="vertical" align="center" size="small">
//                                             <Text strong style={{ fontSize: "16px", color: "#334155" }}>
//                                                 No Queue Generated
//                                             </Text>
//                                             <Text type="secondary" style={{ textAlign: "center" }}>
//                                                 Enter usernames to create a correction queue. 
//                                                 The system will process each user's wallet ledger with precision.
//                                             </Text>
//                                         </Space>
//                                     }
//                                     imageStyle={{ height: 120 }}
//                                     style={{ margin: "64px 0" }}
//                                 >
//                                     <Button 
//                                         type="primary" 
//                                         size="large"
//                                         icon={<PlusOutlined />}
//                                         onClick={generateList}
//                                         style={{ 
//                                             borderRadius: "12px",
//                                             padding: "0 32px",
//                                             height: "48px",
//                                             background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
//                                             border: "none"
//                                         }}
//                                     >
//                                         Create Your First Queue
//                                     </Button>
//                                 </Empty>
//                             )}
//                         </Card>
//                     </Col>
//                 </Row>

//                 {/* Bottom Info Bar
//                 {users.length > 0 && (
//                     <Row style={{ marginTop: "24px" }}>
//                         <Col span={24}>
//                             <Alert
//                                 message={
//                                     <Space>
//                                         <FilterOutlined />
//                                         <Text strong>Processing Guidelines</Text>
//                                     </Space>
//                                 }
//                                 description="Users are processed sequentially. Failed corrections can be retried individually. All corrections are logged for audit purposes."
//                                 type="info"
//                                 showIcon
//                                 style={{ 
//                                     borderRadius: "12px",
//                                     border: "1px solid #dbeafe",
//                                     backgroundColor: "#eff6ff"
//                                 }}
//                             />
//                         </Col>
//                     </Row>
//                 )} */}
//             </div>
//         </div>
//     );
// };

// export default WalletCorrectionPage;


import React, { useState, useCallback } from "react";
import DataTable from "react-data-table-component";
import {
    Tag,
    Button,
    Card,
    Row,
    Col,
    Input,
    Space,
    Typography,
    Alert,
    Spin,
    Statistic,
    Divider,
    Empty,
    Progress,
    Tooltip,
    Badge,
    Popconfirm
} from "antd";
import { toast } from "react-toastify";
import { postRequest } from "./../../../Utils/AppApi";
import { LEDGER_CORRECT_API, CORRECT_KHATABOOK } from "./../../../Utils/appConstants";
import {
    ReloadOutlined,
    ClearOutlined,
    PlusOutlined,
    CheckCircleOutlined,
    ClockCircleOutlined,
    CloseCircleOutlined,
    UserOutlined,
    DatabaseOutlined,
    SafetyCertificateOutlined,
    LoadingOutlined,
    RocketOutlined
} from "@ant-design/icons";

const { TextArea } = Input;
const { Title, Paragraph, Text } = Typography;

const WalletCorrectionPage = ({ history }) => {

    /* ================= STATES ================= */

    const [inputValue, setInputValue] = useState("");
    const [users, setUsers] = useState([]);
    const [processingUser, setProcessingUser] = useState(null);
    const [isProcessingBatch, setIsProcessingBatch] = useState(false);

    // NEW KHATABOOK STATES
    const [khatabookUsername, setKhatabookUsername] = useState("");
    const [khatabookLoading, setKhatabookLoading] = useState(false);

    /* ================= INPUT HANDLER ================= */

    const handleInputChange = useCallback((e) => {
        setInputValue(e.target.value.replace(/\s/g, "").toUpperCase());
    }, []);

    /* ================= GENERATE QUEUE ================= */

    const generateList = useCallback(() => {
        if (!inputValue.trim()) {
            return toast.error("Please enter at least one username");
        }

        const rawUsers = inputValue
            .split(/,|\n/)
            .map(u => u.trim())
            .filter(Boolean);

        const uniqueUsers = [...new Set(rawUsers)].filter(u =>
            u.length > 0 && /^[A-Z0-9]+$/.test(u)
        );

        const list = uniqueUsers.map(u => ({
            key: u,
            username: u,
            status: "PENDING"
        }));

        setUsers(list);
        toast.success(`Queue generated with ${list.length} users.`);
    }, [inputValue]);

    /* ================= UPDATE STATUS ================= */

    const updateStatus = useCallback((username, status) => {
        setUsers(prev =>
            prev.map(u =>
                u.username === username ? { ...u, status } : u
            )
        );
    }, []);

    /* ================= SINGLE LEDGER CORRECTION ================= */

    const handleCorrectWallet = useCallback((row) => {
        if (row.status !== "PENDING") return;

        setProcessingUser(row.username);
        updateStatus(row.username, "PROCESSING");

        const payload = { username: row.username };

        postRequest(LEDGER_CORRECT_API, payload, history)
            .then(res => {
                if (res?.success) {
                    toast.success(`Wallet corrected for ${row.username}`);
                    updateStatus(row.username, "DONE");
                } else {
                    updateStatus(row.username, "FAILED");
                }
            })
            .catch(() => updateStatus(row.username, "FAILED"))
            .finally(() => setProcessingUser(null));
    }, [history, updateStatus]);

    /* ================= BATCH CORRECTION ================= */

    const handleBatchCorrect = useCallback(async () => {
        const pendingUsers = users.filter(u => u.status === "PENDING");
        if (pendingUsers.length === 0) {
            toast.info("No pending users to process");
            return;
        }

        setIsProcessingBatch(true);

        for (const user of pendingUsers) {
            try {
                setProcessingUser(user.username);
                updateStatus(user.username, "PROCESSING");

                const payload = { username: user.username };
                const res = await postRequest(LEDGER_CORRECT_API, payload, history);

                if (res?.success) {
                    updateStatus(user.username, "DONE");
                } else {
                    updateStatus(user.username, "FAILED");
                }

                await new Promise(resolve => setTimeout(resolve, 300));
            } catch {
                updateStatus(user.username, "FAILED");
            } finally {
                setProcessingUser(null);
            }
        }

        setIsProcessingBatch(false);
        toast.success("Batch processing completed");
    }, [users, history, updateStatus]);

    /* ================= CLEAR QUEUE ================= */

    const clearQueue = useCallback(() => {
        setUsers([]);
        setInputValue("");
        toast.info("Queue cleared.");
    }, []);

    /* ================= KHATABOOK CORRECTION ================= */

    const handleCorrectKhatabook = async (isSingle = false) => {
        setKhatabookLoading(true);

        try {
            const payload =
                isSingle && khatabookUsername
                    ? { username: khatabookUsername.trim().toUpperCase() }
                    : {};

            const res = await postRequest(CORRECT_KHATABOOK, payload, history);

            if (res?.success) {
                toast.success(res.message || "KhataBook corrected successfully");
                setKhatabookUsername("");
            } else {
                toast.error(res?.message || "Correction failed");
            }
        } catch {
            toast.error("API request failed");
        } finally {
            setKhatabookLoading(false);
        }
    };

    /* ================= STATUS TAG ================= */

    const statusTag = (status) => {
        const config = {
            DONE: { color: "success", icon: <CheckCircleOutlined />, text: "Completed" },
            FAILED: { color: "error", icon: <CloseCircleOutlined />, text: "Failed" },
            PROCESSING: { color: "processing", icon: <LoadingOutlined spin />, text: "Processing" },
            PENDING: { color: "default", icon: <ClockCircleOutlined />, text: "Pending" }
        };

        const c = config[status] || config.PENDING;

        return (
            <Tag color={c.color} icon={c.icon}>
                {c.text}
            </Tag>
        );
    };

    /* ================= PROGRESS CALC ================= */

    const total = users.length;
    const completed = users.filter(u => u.status === "DONE").length;
    const failed = users.filter(u => u.status === "FAILED").length;
    const pending = users.filter(u => u.status === "PENDING").length;
    const completionPercent = total ? Math.round((completed / total) * 100) : 0;

    /* ================= TABLE ================= */

    const columns = [
        {
            name: "Username",
            selector: row => row.username,
            cell: row => <Text strong>{row.username}</Text>
        },
        {
            name: "Status",
            selector: row => row.status,
            cell: row => statusTag(row.status)
        },
        {
            name: "Action",
            cell: row => (
                row.status === "DONE"
                    ? <Text type="success">Done</Text>
                    : (
                        <Button
                            type="primary"
                            size="small"
                            icon={<ReloadOutlined />}
                            onClick={() => handleCorrectWallet(row)}
                            loading={processingUser === row.username}
                        >
                            Correct
                        </Button>
                    )
            )
        }
    ];

    /* ================= UI ================= */

    return (
        <div style={{ background: "#f8fafc", minHeight: "100vh", padding: "24px" }}>
            <Row gutter={[32, 32]}>

                {/* LEFT COLUMN */}
                <Col xs={24} lg={8}>

                    {/* LEDGER CORRECTION */}
                    <Card
                        title={<Space><DatabaseOutlined />Ledger Correction</Space>}
                        bordered={false}
                        style={{ borderRadius: 16 }}
                    >
                        <Space direction="vertical" style={{ width: "100%" }}>
                            <TextArea
                                rows={5}
                                placeholder="SRPAY1011, SRPAY1012"
                                value={inputValue}
                                onChange={handleInputChange}
                            />

                            <Button type="primary" onClick={generateList} block>
                                Generate Queue
                            </Button>

                            {users.length > 0 && (
                                <>
                                    <Button
                                        type="primary"
                                        icon={<RocketOutlined />}
                                        loading={isProcessingBatch}
                                        onClick={handleBatchCorrect}
                                        block
                                    >
                                        Process All
                                    </Button>

                                    <Button
                                        danger
                                        icon={<ClearOutlined />}
                                        onClick={clearQueue}
                                        block
                                    >
                                        Clear Queue
                                    </Button>
                                </>
                            )}
                        </Space>
                    </Card>

                    {/* KHATABOOK CORRECTION */}
                    <Card
                        title={<Space><SafetyCertificateOutlined />KhataBook Correction</Space>}
                        bordered={false}
                        style={{ borderRadius: 16, marginTop: 24 }}
                    >
                        <Space direction="vertical" style={{ width: "100%" }}>
                            <Input
                                placeholder="Enter Username (Optional)"
                                value={khatabookUsername}
                                onChange={(e) =>
                                    setKhatabookUsername(
                                        e.target.value.replace(/\s/g, "").toUpperCase()
                                    )
                                }
                            />

                            <Popconfirm
                                title="Correct khataBook for this user?"
                                onConfirm={() => handleCorrectKhatabook(true)}
                            >
                                <Button
                                    block
                                    disabled={!khatabookUsername}
                                    loading={khatabookLoading}
                                >
                                    Correct Single User
                                </Button>
                            </Popconfirm>

                            <Popconfirm
                                title="Correct khataBook for ALL users?"
                                onConfirm={() => handleCorrectKhatabook(false)}
                            >
                                <Button
                                    type="primary"
                                    danger
                                    block
                                    loading={khatabookLoading}
                                >
                                    Correct All Users
                                </Button>
                            </Popconfirm>
                        </Space>
                    </Card>
                </Col>

                {/* RIGHT COLUMN */}
                <Col xs={24} lg={16}>
                    <Card bordered={false} style={{ borderRadius: 16 }}>
                        {users.length > 0 ? (
                            <>
                                <Progress percent={completionPercent} />

                                <Row gutter={16} style={{ marginBottom: 16 }}>
                                    <Col span={6}><Statistic title="Total" value={total} /></Col>
                                    <Col span={6}><Statistic title="Pending" value={pending} /></Col>
                                    <Col span={6}><Statistic title="Completed" value={completed} /></Col>
                                    <Col span={6}><Statistic title="Failed" value={failed} /></Col>
                                </Row>

                                <DataTable
                                    columns={columns}
                                    data={users}
                                    pagination
                                    highlightOnHover
                                />
                            </>
                        ) : (
                            <Empty description="No users in queue" />
                        )}
                    </Card>
                </Col>

            </Row>
        </div>
    );
};

export default WalletCorrectionPage;

